const REACT_APP_API_URL = process.env.NODE_ENV === 'production' ? 'https://doc-design.ru:8055' : 'http://localhost:8055';

export { REACT_APP_API_URL };
